import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight, FiZap, FiCamera, FiCpu } = FiIcons;

const CrossSellBlock = ({ variant }) => {
  const { lang } = useLanguage();

  const content = {
    en: {
      gym: {
        title: "More content. More conversations. More trials.",
        body: "Give your AI Lead Assistant better content to work with. I come to your gym and create professional photos and short-form videos designed to attract potential members and drive them into your DMs.",
        disclaimer: "Available as a one-off or monthly content service.",
        button: "See the Gym Content Day →",
        path: "/content-shooting",
        icon: FiCamera
      },
      beauty: {
        title: "Turn Your Treatments Into Content That Starts Conversations",
        body: "Showcase your treatments, expertise and team with professional content designed to build trust and encourage potential clients to message your clinic.",
        disclaimer: "Available as a one-off or monthly content service.",
        button: "Explore Content for Your Clinic →",
        path: "/content-shooting",
        icon: FiCamera
      },
      ai: {
        title: "Your AI Needs Conversations to Work With",
        body: "I create the content that gets people interested enough to start one. Professional photos and short-form videos designed to build trust, create attention and drive more enquiries.",
        disclaimer: "Available as a one-off or monthly content service.",
        button: "Explore Content →",
        path: "/content-shooting",
        icon: FiZap
      },
      content: {
        title: "Already using the AI Lead Assistant?",
        body: "Add a Content Day to create the assets that feed your system.",
        disclaimer: "",
        button: "See the AI Lead Assistant →",
        path: "/ai-lead-agent",
        icon: FiCpu
      }
    },
    es: {
      gym: {
        title: "Más contenido. Más conversaciones. Más pruebas.",
        body: "Dale a tu Asistente de IA mejor contenido con el que trabajar. Voy a tu gimnasio y creo fotos profesionales y vídeos cortos diseñados para atraer miembros potenciales y dirigirlos a tus DMs.",
        disclaimer: "Disponible como servicio único o mensual.",
        button: "Ver el Día de Contenido para Gimnasios →",
        path: "/content-shooting",
        icon: FiCamera
      },
      beauty: {
        title: "Convierte tus Tratamientos en Contenido que Inicia Conversaciones",
        body: "Muestra tus tratamientos, experiencia y equipo con contenido profesional diseñado para generar confianza y animar a los clientes potenciales a enviar un mensaje a tu clínica.",
        disclaimer: "Disponible como servicio único o mensual.",
        button: "Explorar Contenido para tu Clínica →",
        path: "/content-shooting",
        icon: FiCamera
      },
      ai: {
        title: "Tu IA Necesita Conversaciones con las que Trabajar",
        body: "Yo creo el contenido que capta el interés necesario para iniciar una. Fotos profesionales y vídeos cortos diseñados para generar confianza, crear atención y atraer más consultas.",
        disclaimer: "Disponible como servicio único o mensual.",
        button: "Explorar Contenido →",
        path: "/content-shooting",
        icon: FiZap
      },
      content: {
        title: "¿Ya usas el Asistente de IA para Leads?",
        body: "Añade un Día de Contenido para crear el material que alimenta tu sistema.",
        disclaimer: "",
        button: "Ver el Asistente de IA →",
        path: "/ai-lead-agent",
        icon: FiCpu
      }
    }
  };

  const t = content[lang][variant] || content.en[variant];

  return (
    <section className="py-12 px-6 bg-zinc-950">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative group overflow-hidden bg-zinc-900 border border-orange-500/20 rounded-[2.5rem] p-8 md:p-12"
        >
          {/* Background Glow */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-orange-500/5 blur-[100px] pointer-events-none" />
          
          <div className="flex flex-col md:flex-row items-center gap-8 relative z-10">
            <div className="w-16 h-16 bg-zinc-950 border border-white/10 rounded-2xl flex items-center justify-center shrink-0 group-hover:border-orange-500/50 transition-colors">
              <SafeIcon icon={t.icon} className="text-3xl text-orange-500" />
            </div>
            
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-black text-white mb-4 tracking-tighter uppercase">
                {t.title}
              </h3>
              <p className="text-zinc-400 text-lg leading-relaxed mb-6">
                {t.body}
              </p>
              {t.disclaimer && (
                <p className="text-zinc-600 text-sm italic mb-8">
                  {t.disclaimer}
                </p>
              )}
              <Link
                to={t.path}
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-zinc-950 font-black rounded-full hover:bg-orange-500 hover:text-white transition-all transform hover:scale-105 group/btn"
              >
                {t.button}
                <SafeIcon icon={FiArrowRight} className="group-hover/btn:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CrossSellBlock;